import { NavLink } from 'react-router'
import { useTranslation } from 'react-i18next'
import { clsx } from 'clsx'
import { MOBILE_NAV } from './nav'

export function BottomNav() {
  const { t } = useTranslation()
  return (
    <nav
      aria-label={t('nav.menu')}
      className="fixed inset-x-0 bottom-0 z-30 border-t border-line bg-surface-0/90 pb-[env(safe-area-inset-bottom)] backdrop-blur-xl md:hidden"
    >
      <ul className="mx-auto grid h-[68px] max-w-lg grid-cols-5">
        {MOBILE_NAV.map((item) => {
          const Icon = item.icon
          const center = item.key === 'convert'
          return (
            <li key={item.to} className="flex">
              <NavLink
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  clsx(
                    'flex flex-1 flex-col items-center justify-center gap-1 text-[0.7rem] font-medium transition',
                    isActive ? 'text-gold-text' : 'text-subtle hover:text-fg',
                  )
                }
              >
                {({ isActive }) =>
                  center ? (
                    <>
                      <span
                        className={clsx(
                          '-mt-6 flex size-[52px] items-center justify-center rounded-full ring-4 ring-bg transition',
                          'gold-fill shadow-gold',
                          isActive && 'scale-105',
                        )}
                      >
                        <Icon className="size-6" strokeWidth={2.2} />
                      </span>
                      <span>{t(`nav.${item.key}`)}</span>
                    </>
                  ) : (
                    <>
                      <Icon className="size-[1.35rem]" strokeWidth={isActive ? 2.2 : 1.7} />
                      <span>{t(`nav.${item.key}`)}</span>
                    </>
                  )
                }
              </NavLink>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
